import React from "react";
import {
  TextInput,
  Text,
  NumberInput,
  Button,
  Group,
  Select,
} from "@mantine/core";
import { getButtonStyles } from "@/helpers/getButtonStyles";
import { useDarkModeContext } from "@/hooks/contextHooks/useDarkModeContext";
import { getFormStyles } from "@/helpers/getFormStyles";

interface WingCardProps {
  id: string;
  label: string;
  x: number;
  y: number;
  color: string;
  model: string;
  models: { value: string; label: string }[];
  onRemove: (id: string) => void;
  onUpdate: (
    id: string,
    label: string,
    x: number,
    y: number,
    color: string,
    model: string,
  ) => void;
  onClone: (id: string) => void;
  scaleX: number;
  scaleY: number;
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  readOnly?: boolean;
}

const WingCardComponent: React.FC<WingCardProps> = ({
  id,
  label,
  x,
  y,
  color,
  model,
  models,
  onRemove,
  onUpdate,
  onClone,
  scaleX,
  scaleY,
  minX,
  maxX,
  minY,
  maxY,
  readOnly = false,
}) => {
  // const isDisabled = readOnly;

  const { isDarkMode } = useDarkModeContext();
  const buttonStyles = getButtonStyles(isDarkMode);
  const formStyles = getFormStyles(isDarkMode);

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate(id, e.target.value, x, y, color, model);
  };

  const handleColorChange = (value: string) => {
    onUpdate(id, label, x, y, value, model);
  };

  const handleXChange = (value: string | number) => {
    const numericValue = typeof value === "string" ? parseFloat(value) : value;
    if (!isNaN(numericValue)) {
      onUpdate(id, label, numericValue, y, color, model);
    }
  };

  const handleYChange = (value: string | number) => {
    const numericValue = typeof value === "string" ? parseFloat(value) : value;
    if (!isNaN(numericValue)) {
      onUpdate(id, label, x, numericValue, color, model);
    }
  };

  const handleModelChange = (value: string | null) => {
    if (value) {
      onUpdate(id, label, x, y, color, value);
    }
  };

  return (
    <div>
      {readOnly ? (
        <>
          <Text>
            <strong>Sail Name:</strong> {label}
          </Text>
          <Text>
            <strong>Model:</strong> {model}
          </Text>
          <Text>
            <strong>Position X (m):</strong> {x}
          </Text>
          <Text>
            <strong>Position Y (m):</strong> {y}
          </Text>
          {/* <div style={{ display: 'flex', alignItems: 'center' }}>
            <Text><strong>Color:</strong></Text>
            <div 
              style={{ 
                width: 24, 
                height: 24, 
                backgroundColor: color, 
                borderRadius: 4, 
                marginLeft: 8 
              }} 
            />
          </div> */}
        </>
      ) : (
        <>
          <TextInput
            label="Sail Name"
            value={label}
            onChange={handleLabelChange}
            styles={formStyles}
          />
          <Select
            label="Model"
            data={models}
            value={model}
            onChange={(value) => handleModelChange(value)}
            styles={formStyles}
          />
          <NumberInput
            label="Position X (m)"
            value={y}
            onChange={handleYChange}
            min={minY}
            max={maxY}
            styles={formStyles}
          />
          <NumberInput
            label="Position Y (m)"
            value={x}
            onChange={handleXChange}
            min={minX}
            max={maxX}
            styles={formStyles}
          />

          {/* <ColorInput label="Color" value={color} onChange={handleColorChange} /> */}
          <Group mt="md">
            <Button onClick={() => onRemove(id)} style={buttonStyles}>
              Remove
            </Button>
            <Button onClick={() => onClone(id)} style={buttonStyles}>
              Clone
            </Button>
          </Group>
        </>
      )}
    </div>
  );
};

export default WingCardComponent;
